import { getFloatValue } from '@/common/helpers/numbers';
import { CurrencyCode } from '@/finance/enums/currency-code.enum';

import { InvalidMembershipCurrencyError } from './errors';
import { getDisloyaltyMembershipPrice } from './utils/get-disloyalty-membership-price';

export interface GA4DisloyaltyPurchaseEvent {
  event: 'purchase_disloyalty';
  /**
   * This is PMS reservation ID with -DIS appended
   */
  transaction_id: `${string}-DIS`;
  destination: string;
  brand: string;
  disloyalty_type: 'sign_up';
  currency: string;
  value: number;
  items: {
    item_name: 'disloyalty membership';
    item_category: 'annual payment';
    quantity: 1;
    price: number;
  }[];
}

export function buildDisloyaltyPurchaseEvent({
  currencyCode,
  brandReferenceId,
  hotelReferenceId,
  pmsId,
}: {
  currencyCode: CurrencyCode;
  brandReferenceId: string;
  hotelReferenceId: string;
  pmsId: string;
}): GA4DisloyaltyPurchaseEvent | undefined {
  const membershipPrice = getDisloyaltyMembershipPrice(currencyCode);
  if (!membershipPrice) {
    throw new InvalidMembershipCurrencyError(currencyCode);
  }

  return {
    event: 'purchase_disloyalty',
    brand: brandReferenceId,
    currency: currencyCode,
    destination: hotelReferenceId,
    disloyalty_type: 'sign_up',
    transaction_id: `${pmsId}-DIS`,
    value: getFloatValue(membershipPrice.value, membershipPrice.decimal),
    items: [
      {
        item_name: 'disloyalty membership',
        item_category: 'annual payment',
        quantity: 1,
        price: getFloatValue(membershipPrice.value, membershipPrice.decimal),
      },
    ],
  };
}
